<!-- eslint-disable -->
<template>
  <div v-if="visible" class="compare-overlay" @click="close">
    <div class="compare-container" @click.stop>
      <div class="compare-header">
        <h2 class="compare-title">Comparar Amostras</h2>
        <button class="close-button" @click="close">✕</button>
      </div>

      <div v-if="loading" class="compare-loading">
        <b-spinner />
        <p>Carregando imagens... ({{ loadedCount }}/{{ total }})</p>
      </div>

      <div v-else-if="images.length === 0" class="compare-empty">
        <i class="fas fa-images"></i>
        <p>Nenhuma imagem disponível para as amostras selecionadas.</p>
      </div>

      <div v-else class="compare-body">
        <div class="compare-grid" :class="gridClass">
          <div
            v-for="img in images"
            :key="img.analysisId"
            class="compare-card"
            :class="{ 'compare-card--selected': selectedForZoom === img.analysisId }"
            @click="toggleZoom(img.analysisId)"
          >
            <div class="compare-card-label">
              <span class="compare-card-name">{{ img.sampleName }}</span>
            </div>
            <div class="compare-card-image-wrapper">
              <img :src="img.imageUrl" :alt="img.sampleName" class="compare-card-image" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="selectedForZoom" class="zoom-overlay" @click="selectedForZoom = null">
        <div class="zoom-content" @click.stop>
          <button class="close-button zoom-close" @click="selectedForZoom = null">✕</button>
          <div class="zoom-label">{{ zoomedImage.sampleName }}</div>
          <img :src="zoomedImage.imageUrl" :alt="zoomedImage.sampleName" class="zoom-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
    images: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    loadedCount: { type: Number, default: 0 },
    total: { type: Number, default: 0 }
  },
  data () {
    return {
      selectedForZoom: null
    }
  },
  computed: {
    gridClass () {
      const count = this.images.length
      if (count === 1) return 'grid-1'
      if (count === 2) return 'grid-2'
      if (count <= 4) return 'grid-2'
      return 'grid-3'
    },
    zoomedImage () {
      return this.images.find(i => i.analysisId === this.selectedForZoom) || {}
    }
  },
  methods: {
    close () {
      this.selectedForZoom = null
      this.$emit('close')
    },
    toggleZoom (id) {
      this.selectedForZoom = this.selectedForZoom === id ? null : id
    }
  },
  watch: {
    visible (val) {
      if (!val) this.selectedForZoom = null
    }
  }
}
</script>

<style scoped>
.compare-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
  padding: 20px;
}

.compare-container {
  background: #fff;
  width: 95%;
  max-width: 1400px;
  height: 90vh;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.compare-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  flex-shrink: 0;
}

.compare-title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
}

.close-button {
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.35);
}

.compare-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #555;
  font-size: 1rem;
}

.compare-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #999;
}

.compare-empty i {
  font-size: 3rem;
}

.compare-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.compare-grid {
  display: grid;
  gap: 16px;
  width: 100%;
}

.grid-1 {
  grid-template-columns: 1fr;
  max-width: 800px;
  margin: 0 auto;
}

.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.compare-card {
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.25s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.compare-card:hover {
  border-color: #FF8C42;
  box-shadow: 0 4px 20px rgba(255, 140, 66, 0.2);
  transform: translateY(-2px);
}

.compare-card--selected {
  border-color: #FF8C42;
  box-shadow: 0 4px 20px rgba(255, 140, 66, 0.3);
}

.compare-card-label {
  padding: 10px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compare-card-name {
  font-weight: 600;
  font-size: 0.85rem;
  color: #2c3e50;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.compare-card-image-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  min-height: 200px;
}

.compare-card-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height: 400px;
}

/* Zoom overlay */
.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6000;
  padding: 20px;
}

.zoom-content {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.zoom-close {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 1;
  background: #FF8C42;
}

.zoom-close:hover {
  background: #FF7A29;
}

.zoom-label {
  color: #fff;
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 12px;
  text-align: center;
}

.zoom-image {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
}

/* Responsive */
@media (max-width: 992px) {
  .grid-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .compare-overlay {
    padding: 10px;
  }

  .compare-container {
    width: 100%;
    height: 95vh;
    border-radius: 12px;
  }

  .compare-header {
    padding: 14px 16px;
  }

  .compare-title {
    font-size: 1.1rem;
  }

  .compare-body {
    padding: 12px;
  }

  .grid-2,
  .grid-3 {
    grid-template-columns: 1fr;
  }

  .compare-card-image {
    max-height: 250px;
  }
}

@media (max-width: 576px) {
  .compare-title {
    font-size: 1rem;
  }

  .compare-card-name {
    font-size: 0.75rem;
  }

  .compare-card-image {
    max-height: 200px;
  }
}
</style>
